import { put, takeLatest } from "redux-saga/effects";
import { IAdditionalCommentsLimit } from "src/common/types";
import { getAdditionalCommentsLimit } from "../actions";

export function* fetchAdditionalCommentsLimit() {
  try {
    const data: IAdditionalCommentsLimit = yield getAdditionalCommentsLimit();

    yield put({
      payload: data,
      type: "GET_ADDITIONAL_COMMENTS_LIMIT_FULFILLED"
    });
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.error(e);
    yield put({
      type: "GET_ADDITIONAL_COMMENTS_LIMIT_REJECTED"
    });
  }
}

export function* additionalCommentsLimitWatcher() {
  yield takeLatest("GET_ADDITIONAL_COMMENTS_LIMIT", fetchAdditionalCommentsLimit);
}
